import React from "react";

import { ApprovedForSocial, Story } from "chq";

import BodyTags from "components/common/BodyTags";
import LazyEditorOutput from "components/editor/LazyEditorOutput";
import { Tag } from "@culturehq/components";
import { Trans } from "app/utils";

type StoryPromptTitleProps = {
  approvedContent?: ApprovedForSocial;
  story: Story;
  onReviewClicked: (entity: Story | ApprovedForSocial) => void;
};

const StoryPromptTitle: React.FC<StoryPromptTitleProps> = ({
  approvedContent, story, onReviewClicked
}) => (
  <td className="StoryTable-Details StoryTable-clickable" onClick={() => onReviewClicked(approvedContent || story)}>
    {story.question.storyQuestionType === "old_prompt" ? (
      <>
        <div className="StoryTable-Details__Header">
          <h4 className="StoryTable-Details__Title">{story.question.question}</h4>
          {(story.question.status === "hidden") && (
            <Tag className="ChildPrompts__Tag chq-tag-bk"><Trans>Hidden</Trans></Tag>
          )}
        </div>
        <LazyEditorOutput output={story.body} numberOfTagsToshow={3} showTags={false} preview />
        <BodyTags hideLinks numberOfTagsToshow={3} tags={story.bodyTags} />
      </>
    ) : (
      <>
        <div className="StoryTable-Details__Header">
          <h4 className="StoryTable-Details__Title">{story.question.parentStoryQuestion?.question || story.question.question}</h4>
          {(story.question.status === "hidden" || story.question.parentStoryQuestion?.status === "hidden") && (
            <Tag className="ChildPrompts__Tag chq-tag-bk"><Trans>Hidden</Trans></Tag>
          )}
        </div>
        {story.question.parentStoryQuestion && <section>{story.question.question}</section>}
        <LazyEditorOutput output={story.body} numberOfTagsToshow={3} showTags={false} />
        <BodyTags hideLinks numberOfTagsToshow={3} tags={story.bodyTags} />
      </>
    )}
  </td>
);

export default StoryPromptTitle;
